import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../services/session.service';
import { SessionStorageKeys } from '../../enum/session-storage-keys';
import { PermissionsService } from '../../services/permissions.service';
import { onAuthStateChanged } from 'firebase/auth';
import { FiltrosDocumentosService } from '../../services/filtros-documentos.service';
import { FiltrosSpecsheetsService } from '../../services/filtros-specsheets.service';
import { FilterStateService } from '../../services/filtros-forms.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  userName: string  = 'Braulio Romero';
  user:any;
  hasAccessToDocuments: boolean = false;

  constructor(
    public authenticationService: SessionService,
    private permissionsService: PermissionsService,
    public filtradoDocsService: FiltrosDocumentosService,
    public filtradoSpecsService: FiltrosSpecsheetsService,
    public filterStateSvc: FilterStateService
  ) {
    this.checkAuth();
  }

  ngOnInit(): void {
    //se autentica el usuario
      this.permissionsService.authenticateWithToken().then(() => {
        onAuthStateChanged(this.permissionsService['auth'], (user) => {
          if (user) {
            const userId = user.uid;
            this.permissionsService.listenToFirestoreSubcollection('users', userId, 'permissions')
              .subscribe(async (data: any) => {
                const permissions = await this.permissionsService.getUserPermissions(userId).toPromise();
                if (permissions.success) {
                  this.permissionsService.setPermissions = permissions.data;
                  this.permissionsService.updatePermissions(permissions.data);
                }
              });
          } else {
            console.error('Firebase no autenticado');
          }
        });
      });

      // se suscribe a los cambios que tenga el observable de permisos para estar "escuchando" cuando se actualicen
      this.permissionsService.getPermissionsObservable().subscribe((permissions: any[]) => {
        this.hasAccessToDocuments = this.permissionsService.checkModuleAccess('documents', 'view'); // en este caso solo valido si tiene acceso al modulo documents y si tiene en actions: view == true para que se muestre el botón en el menú
        // console.log("Acceso a documentos:", this.hasAccessToDocuments);
      });

  }

  menuclose() {
    this.filtradoDocsService.limpiarFiltros();
    this.filtradoSpecsService.limpiarFiltros();
    this.filterStateSvc.clear();
    const body = document.getElementsByTagName('body')[0];
    if (body.classList.contains('sidebar-pushcontent') === false) {
      body.classList.add('menu-close');
    } else {
      if (window.innerWidth <= 992) {
        body.classList.add('menu-close');
      }
    }
  }

  private async checkAuth() {
    const authInfoString = sessionStorage.getItem(SessionStorageKeys.SESSION);
    let authInfo: any = null;
    if (authInfoString) {
      authInfo = JSON.parse(authInfoString);
      this.user = authInfo.user;
    }
  }

}
